import Learning from "../components/Learning";
import Nav from "../components/Nav";
import { useNavigate } from 'react-router-dom';
import Preloader from "../components/Preloader.js"
import { useEffect, useState } from "react";
import axios from "axios";

const LearningPage = () =>{
    
    const base_url = process.env.REACT_APP_BASE_URL;
    const [loading, setLoading] = useState(false);
    // const [totalUsers, setTotalUsers] = useState(0)
    const [userActivity, setUserActivity] = useState(new Date());
    
    const api = axios.create({
        baseURL: `${base_url}`
    });

    // Set the authorization token for all requests
    api.interceptors.request.use((config) => {
        // Add your authorization token logic here
        const token = sessionStorage.getItem('token');
        config.headers.Authorization = `Bearer ${token}`;
        return config;
    });

    // Add interceptor to log the user out on error
    api.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response.status === 401) {
                // Unauthorized error, log user out
                sessionStorage.removeItem('token');
                navigate("/login");
            }
            return Promise.reject(error);
        }
    );

    // Update user activity timestamp whenever there is any user interaction
    const updateUserActivity = () => {
        setUserActivity(new Date());
    };

    const navigate = useNavigate();

    useEffect(() => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 1000);

        // Listen for user interaction events
        window.addEventListener('mousemove', updateUserActivity);
        window.addEventListener('keydown', updateUserActivity);

        // Set up the inactivity timeout
        const inactivityTimeout = setInterval(() => {
            const currentTime = new Date();
            const elapsedTime = (currentTime - userActivity) / 1000; // Convert to seconds
            if (elapsedTime > 180) { // 3 minutes in seconds
                // User is inactive for 3 minutes, log them out
                sessionStorage.removeItem('token');
                navigate("/login");
            }
        }, 1000);


        // Cleanup event listeners and timeout when component unmounts
        return () => {
            window.removeEventListener('mousemove', updateUserActivity);
            window.removeEventListener('keydown', updateUserActivity);
            clearInterval(inactivityTimeout);
        };
    }, []);

    if (!sessionStorage.getItem('token')) {
        navigate("/login")
    } else {
        if (loading) {
            return (
                <Preloader />
            )
        } else {
            return(
                <>
                    <Nav />
                    <div className="container-fluid">
                        <Learning />
                    </div>
                </>
            )
        }
    }
}
export default LearningPage